import rAxios from "utils/rAxios";
import { ITimerResponse } from "./timer.model";

export const onTimerGet = (): Promise<ITimerResponse> =>
	rAxios.get("/user/timer");
